// src/components/registration/MerchandiseSelector.js
// Updated: 10/17/2025 10:51 AM

import React from 'react';

const MerchandiseSelector = ({ merchandise, attendee, onMerchChange }) => {
  if (!merchandise || merchandise.length === 0) {
    return null;
  }

  // For this version, we'll assume only one merchandise item (e.g., a T-shirt)
  const tShirtOptions = merchandise.find(item => item.itemName.toLowerCase().includes('t-shirt'));

  if (!tShirtOptions) {
    return null;
  }

  const handleSizeChange = (e) => {
    const selectedSize = e.target.value;
    const sizeInfo = tShirtOptions.sizes.find(s => s.size === selectedSize);
    onMerchChange(tShirtOptions.itemName, selectedSize, sizeInfo.upcharge);
  };

  return (
    <div className="w-full md:w-1/3">
      <label htmlFor={`tshirt-${attendee.id}`} className="block text-sm font-medium text-gray-700">
        T-Shirt Size
      </label>
      <select
        id={`tshirt-${attendee.id}`}
        value={attendee.tshirtSize}
        onChange={handleSizeChange}
        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md"
      >
        <option value="">No T-Shirt</option>
        {tShirtOptions.sizes.map((sizeInfo) => (
          <option key={sizeInfo.size} value={sizeInfo.size}>
            {sizeInfo.size} {sizeInfo.upcharge > 0 && `(+$${sizeInfo.upcharge.toFixed(2)})`}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MerchandiseSelector;